import { getImagesArray } from '../../../../hooks/useImagesArray';
import ImageViewer from '../../../ImageViewer';

import { Container, Item, ItemLeft, ItemRight, Title, ViewerContainer } from './styles';

const ItemComponent = ({ image }) => {
  return (
    <Item>
      <ItemLeft>
        <ViewerContainer>
          <ImageViewer
            imageId={image.imageId}
            fullscreen={false}
            containerStyle={{
              width: '64px',
              height: '64px',
            }}
          />
        </ViewerContainer>
      </ItemLeft>
      <ItemRight>
        <Title>{image.legend}</Title>
      </ItemRight>
    </Item>
  );
};

const LocationOnFPSOCompareComponent = ({ images }) => {
  const { imageArray } = getImagesArray(images || [], 1);

  return (
    <Container>
      {imageArray.map((image, index) => (
        <ItemComponent
          key={index}
          image={image}
        />
      ))}
    </Container>
  );
};

export default LocationOnFPSOCompareComponent;
